import { getCookie } from '@/helpers/cookieMetods';
import type { EntityId } from '../types/common';
import type { UserSeenNews } from '../types/news';
import { apiUrl, domain, parseJsonOrThrow } from './http';
import { JSON_POST_HEADERS } from './constants';

/** Normalizes `newsviews.php` JSON to `UserSeenNews` (`false` or a list of post ids). */
const parseSeenNews = (body: unknown): UserSeenNews => {
  if (body === false) return false;
  if (!Array.isArray(body)) return false;
  const ids: EntityId[] = [];
  for (const x of body) {
    if (typeof x === 'string' || typeof x === 'number') {
      if (typeof x === 'number' && !Number.isFinite(x)) continue;
      ids.push(x);
    }
  }
  return ids;
};

export const getSeenNews = (
  userID: EntityId | undefined
): Promise<UserSeenNews> =>
  fetch(`${domain}/php/newsviews.php`, {
    method: 'POST',
    headers: JSON_POST_HEADERS,
    body: JSON.stringify({ userID }),
  })
    .then((response) => parseJsonOrThrow<unknown>(response))
    .then(parseSeenNews);

export const sendUserProfile = (
  data:
    | Record<string, unknown>
    | { id?: string; displayName?: string; [key: string]: unknown }
): Promise<Response> => {
  const token = getCookie('_form_token');
  const currentBody = { ...data, token };
  return fetch(`${domain}/php/userreg.php`, {
    method: 'POST',
    headers: JSON_POST_HEADERS,
    body: JSON.stringify(currentBody),
  });
};

/** One entry in the roster reported to `useres-no-portal.php`. */
export interface PortalUserEntry {
  name: string;
  usercode: string;
}

/** Reports the full org roster to `useres-no-portal.php`. Fire-and-forget. */
export const sendUsersList = (users: PortalUserEntry[]): Promise<Response> =>
  fetch(apiUrl('/php/useres-no-portal.php'), {
    method: 'POST',
    headers: JSON_POST_HEADERS,
    body: JSON.stringify({ users }),
  });

export const addIdToSeenNews = (
  newsID: EntityId,
  userID: EntityId
): Promise<Response> => {
  const token = getCookie('_form_token');
  return fetch(`${domain}/php/newsviewadd.php`, {
    method: 'POST',
    headers: JSON_POST_HEADERS,
    body: JSON.stringify({ newsID, userID, token }),
  });
};
